import { render, staticRenderFns } from "./EmailsWidget.vue?vue&type=template&id=6b64cb04&scoped=true"
import script from "./EmailsWidget.vue?vue&type=script&lang=js"
export * from "./EmailsWidget.vue?vue&type=script&lang=js"
import style0 from "./EmailsWidget.vue?vue&type=style&index=0&id=6b64cb04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b64cb04",
  null
  
)

/* custom blocks */
import block0 from "./EmailsWidget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports